import { b64toBlob, exportIMG } from '~core';
import { getState } from '~src/state';
import { cleanBase64, getMultiplier } from '~src/utils';
import Swal from 'sweetalert2';
import { getUser } from '~src/user';
import { showSidebarTab } from '~src/sidebarLegacy';
import { closeNavbarSubmenu } from '~core/navbar/submenus';
import { prepareCanvasVisualExportSelection } from './prepareCanvasVisualExportSelection';

export const handleExportToAttachment = async () => {
  const { selection } = prepareCanvasVisualExportSelection({
    canvas: window.canvas,
  });

  const { user } = await getUser();
  if (user.org_pointer.tipo_istanza === 'demo') {
    Swal.fire({
      title: 'Attenzione!',
      html:
        'Non &egrave; possibile esportare immagini durante il periodo di prova. Contattaci per maggiori informazioni.',
      icon: 'warning',
      showCancelButton: false,
      showCloseButton: true,
      confirmButtonText: 'Chiudi',
      confirmButtonColor: '#278e8e',
    });
    return;
  }

  let blob;

  Swal.fire({
    text: "Sto esportando l'immagine...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.showLoading();
    },
  });

  if (selection) {
    const imageBase64 = cleanBase64(selection.toDataURL());
    blob = b64toBlob(imageBase64.base64, imageBase64.contentType);
  } else {
    const project = getState('selected.tipo');
    const image = exportIMG(
      1,
      project.outputDpi,
      'blob',
      'png',
      false,
      getMultiplier()
    );
    blob = image.blob;
  }
  const attachmentsUploader = getState('uploader.allegati');

  attachmentsUploader.addFile({
    type: 'image/png',
    data: blob,
  });

  await attachmentsUploader.upload();
  attachmentsUploader.cancelAll();

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata allegata.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
  setTimeout(() => {
    Swal.close();
  }, 2000);
  showSidebarTab('allegati');
  closeNavbarSubmenu('export');
};

window.exportToAttachment = handleExportToAttachment;
